'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { cx } from '../../../internal/cx.js';
import { ChevronDownGlyph } from '../../../internal/icons.js';
/**
 * Stacked disclosure sections. Enter/Space toggle, arrow keys move between
 * headers, Home/End jump to the first and last. Built on Radix Accordion.
 */
export const Accordion = forwardRef(function Accordion({ className, ...rest }, ref) {
    return _jsx(AccordionPrimitive.Root, { ref: ref, ...rest, className: cx('mn-accordion', className) });
});
export const AccordionItem = forwardRef(function AccordionItem({ className, ...rest }, ref) {
    return (_jsx(AccordionPrimitive.Item, { ref: ref, ...rest, className: cx('mn-accordion__item', className) }));
});
export const AccordionTrigger = forwardRef(function AccordionTrigger({ headingAs: Heading = 'h3', className, children, ...rest }, ref) {
    return (_jsx(AccordionPrimitive.Header, { asChild: true, children: _jsx(Heading, { className: "mn-accordion__header", children: _jsxs(AccordionPrimitive.Trigger, { ref: ref, ...rest, className: cx('mn-accordion__trigger', className), children: [_jsx("span", { className: "mn-accordion__label", children: children }), _jsx(ChevronDownGlyph, { className: "mn-accordion__chevron" })] }) }) }));
});
export const AccordionContent = forwardRef(function AccordionContent({ className, children, ...rest }, ref) {
    return (_jsx(AccordionPrimitive.Content, { ref: ref, ...rest, className: cx('mn-accordion__content', className), children: _jsx("div", { className: "mn-accordion__body", children: children }) }));
});
//# sourceMappingURL=accordion.js.map